import { render, staticRenderFns } from "./bookerFlights.vue?vue&type=template&id=6491ecd6&scoped=true"
import script from "./bookerFlights.vue?vue&type=script&setup=true&lang=js"
export * from "./bookerFlights.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bookerFlights.vue?vue&type=style&index=0&id=6491ecd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6491ecd6",
  null
  
)

export default component.exports